<template>
  <v-app>
    <component :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script setup>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  const layout = computed(() => {
    return (route?.meta?.layout || 'default') + '-layout'
  })

  console.log('Layout:', layout.value)
</script>
